import React, { useState } from 'react';
import clsx from 'clsx';

import { Product } from '@interfaces/models/product';
import ISizeGuide from '@components/size-guide/size-guide';

import styles from './size-guide-modal.module.scss';

type SizeGuideModalProps = {
  universeId: Product['universe']['id'];
  productCategoryId: Product['category']['id'];
  sizeGuideStandard: Product['size']['standard'];
  // If size is present, we can color the row and the cell in the table
  sizeGuideSize?: Product['size']['size'];
  modalDialogTitleId?: string;
};

const SizeGuideModal: React.FC<SizeGuideModalProps> = (props): React.JSX.Element => {
  const [title, setTitle] = useState('');

  return (
    <>
      <h2
        className={clsx('vc-modal__title', styles.sizeGuide__title)}
        id={props.modalDialogTitleId}
      >
        {title}
      </h2>
      <div className={clsx('vc-modal__content', styles.sizeGuide__modalContent)}>
        <ISizeGuide
          {...props}
          onTitleChange={setTitle}
        />
      </div>
    </>
  );
};

export default SizeGuideModal;
